import api from "./api"

/**
 * Config do PDVoz por estabelecimento (endpoints em sistemaadm: PdvozResource).
 * Auth = o mesmo Basic que o login guarda em localStorage "chaveSistema" — a PWA
 * usa o MESMO endpoint pra LER a config depois do login.
 */
const authHeader = () => localStorage.getItem("chaveSistema") || ""

export async function getPdvozConfig(
    idEstabelecimento: number | string
): Promise<Record<string, any>> {
    const { data } = await api.get(`pdvoz/config/${idEstabelecimento}`, {
        headers: { Authorization: authHeader() },
    })
    // o backend devolve "{}" quando nunca foi salvo
    return data && typeof data === "object" ? data : {}
}

export async function salvarPdvozConfig(
    config: Record<string, any>,
    idEstabelecimento: number | string
): Promise<void> {
    await api.post(`pdvoz/config/${idEstabelecimento}`, config, {
        headers: {
            "Content-Type": "application/json",
            Authorization: authHeader(),
        },
    })
}
